module.exports = __webpack_public_path__ + "img/trip(8).dd273449.webp";